import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Link as GatsbyLink } from 'gatsby';
import { Link as MuiLink, withStyles } from '@material-ui/core';
import { isEmpty } from 'lodash';

const styles = () => ({
  root: {},
});

function Link({ classes, className, children, to, target, ...otherProps }) {
  const internal = useMemo(() => /^\/(?!\/)/.test(to), [to]);

  if (isEmpty(to)) {
    return (
      <span {...otherProps} className={clsx(classes.root, className)}>
        {children}
      </span>
    );
  }
  if (internal && target !== '_blank') {
    return (
      <MuiLink {...otherProps} component={GatsbyLink} className={clsx(classes.root, className)} to={to}>
        {children}
      </MuiLink>
    );
  }

  return (
    <MuiLink {...otherProps} target={target} className={clsx(classes.root, className)} href={to}>
      {children}
    </MuiLink>
  );
}

Link.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  to: PropTypes.string,
  target: PropTypes.string,
};

Link.defaultProps = {
  classes: {},
  className: null,
  children: null,
  to: null,
  target: null,
};

export default withStyles(styles)(Link);
